// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__5HGLo","list":"PatternAutocomplete_list__3Sndo"};